module.exports = __webpack_public_path__ + "static/media/duration.dc2e1293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/duration.png
// module id = 38
// module chunks = 0